export async function updateGuide(dealerId: string, data: any) {
  const url = `/internal-api/dealer/guide?id=${dealerId}`;

  try {
    const response = await fetch(url, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Ошибка при обновлении дилера: ", error);
    throw error;
  }
}
